// import axios from "axios";
// import { getAppUrl } from "../functions/getEnv";

// class ErrorLogger {
//   constructor(apiEndpoint) {
//     this.apiEndpoint = apiEndpoint;
//   }

//   async logError(error, context = "N/A") {
//     const timestamp = new Date().toISOString();
//     const errorMessage = error.message || "Unknown error";
//     const errorName = error.name || "Error";
//     const stackTrace = error.stack || "N/A";
//     const errorLocation = error.config ? error.config.url : "N/A";
//     const requestData = error.config ? JSON.stringify(error.config.data) : "N/A";
//     const responseData = error.response ? JSON.stringify(error.response.data) : "N/A";

//     if (errorMessage === "Unknown error" && stackTrace === "N/A" && errorLocation === "N/A") {
//       return;
//     }

//     const errorDetails = {
//       timestamp,
//       context,
//       errorMessage,
//       errorName,
//       stackTrace,
//       errorLocation,
//       requestData,
//       responseData,
//     };

//     try {
//       await axios.post(this.apiEndpoint, errorDetails);
//     } catch (logError) {
//       console.error("Failed to send error log to server:", logError);
//     }
//   }
// }

// const apiEndpoint = getAppUrl(process.env.REACT_APP_NODE_ENV) + "/log-error"; 
// const errorLogger = new ErrorLogger(apiEndpoint);

// window.onerror = function (message, source, lineno, colno, error) {
//   const stackTrace = error ? error.stack : "N/A";
//   const errorLocation = `${source}:${lineno}:${colno}`;
//   errorLogger.logError(
//     {
//       message,
//       stack: stackTrace,
//       config: { url: errorLocation },
//     },
//     source
//   );
// };

// axios.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     const filename = error.config ? error.config.url : "N/A";
//     errorLogger.logError(error, filename);
//     return Promise.reject(error);
//   }
// );

// export default errorLogger;



// client/src/ErrorLogger.js (frontend)
// import axios from "axios";
// import { getAppUrl } from "../functions/getEnv";

// class ErrorLogger {
//   constructor(apiEndpoint) {
//     this.apiEndpoint = apiEndpoint;
//   }

//   async logError(error, context = "N/A", extras = {}) {
//     const ts = new Date().toISOString();
//     const isAxios = !!(error && error.isAxiosError);
//     const errorMessage = error?.message || (typeof error === "string" ? error : "Unknown error");
//     const errorName = error?.name || (isAxios ? "AxiosError" : "Error");
//     const stackTrace = error?.stack || "N/A";

//     const config = error?.config || {};
//     const errorLocation =
//       config?.url ||
//       (typeof window !== "undefined" && window.location ? window.location.href : "N/A");

//     // Avoid logging giant bodies
//     const requestData = config?.data ? (() => {
//       try { return JSON.stringify(config.data).slice(0, 2000); } catch { return "[unserializable]"; }
//     })() : null;

//     const responseData = error?.response?.data ? (() => {
//       try { return JSON.stringify(error.response.data).slice(0, 2000); } catch { return "[unserializable]"; }
//     })() : null;

//     const payload = {
//       timestamp: ts,
//       context,
//       errorMessage,
//       errorName,
//       stackTrace,
//       errorLocation,
//       requestData,
//       responseData,
//       ...extras,
//     };

//     // Deduplicate no-signal events
//     if (errorMessage === "Unknown error" && stackTrace === "N/A" && errorLocation === "N/A") return;

//     try {
//       await axios.post(this.apiEndpoint, payload, { withCredentials: true });
//     } catch (e) {
//       // Last-resort console
//       // eslint-disable-next-line no-console
//       console.error("Failed to send error log to server:", e);
//     }
//   }
// }

// const base = getAppUrl(process.env.NODE_ENV || process.env.REACT_APP_NODE_ENV);
// const apiEndpoint = `${base.replace(/\/$/, "")}/log-error`;
// const errorLogger = new ErrorLogger(apiEndpoint);

// // Global window errors
// window.onerror = function (message, source, lineno, colno, error) {
//   const stackTrace = error ? error.stack : "N/A";
//   const errorLocation = `${source}:${lineno}:${colno}`;
//   errorLogger.logError({ message, stack: stackTrace }, source || "window.onerror");
// };

// axios.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     const where = error?.config?.url || "axios.response";
//     errorLogger.logError(error, where);
//     return Promise.reject(error);
//   }
// );

// export default errorLogger;


import axios from "axios";
import { getAppUrl } from "../functions/getEnv";

class ErrorLogger {
  constructor(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
  }

  async logError(error, context = "N/A", extras = {}) {
    const ts = new Date().toISOString();
    const isAxios = !!(error && error.isAxiosError);
    const errorMessage = error?.message || (typeof error === "string" ? error : "Unknown error");
    const errorName = error?.name || (isAxios ? "AxiosError" : "Error");
    const stackTrace = error?.stack || "N/A";

    const config = error?.config || {};
    const errorLocation =
      config?.url ||
      (typeof window !== "undefined" && window.location ? window.location.href : "N/A");

    // Avoid logging giant bodies
    const requestData = config?.data ? (() => {
      try {
        return JSON.stringify(config.data).slice(0, 2000);
      } catch {
        return "[unserializable]";
      }
    })() : null;

    const responseData = error?.response?.data ? (() => {
      try {
        return JSON.stringify(error.response.data).slice(0, 2000);
      } catch {
        return "[unserializable]";
      }
    })() : null;

    const payload = {
      timestamp: ts,
      context,
      errorMessage,
      errorName,
      stackTrace,
      errorLocation,
      requestData,
      responseData,
      ...extras,
    };

    // Deduplicate no-signal events
    if (errorMessage === "Unknown error" && stackTrace === "N/A" && errorLocation === "N/A") {
      return;
    }

    try {
      await axios.post(this.apiEndpoint, payload, {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        }
      });
    } catch (e) {
      // Last-resort console
      console.error("Failed to send error log to server:", e);
    }
  }
}

const base = getAppUrl(import.meta.env.MODE || import.meta.env.VITE_NODE_ENV);
const apiEndpoint = `${base.replace(/\/$/, "")}/log-error`;
const errorLogger = new ErrorLogger(apiEndpoint);

// Global window errors
if (typeof window !== 'undefined') {
  window.onerror = function (message, source, lineno, colno, error) {
    const stackTrace = error ? error.stack : "N/A";
    const errorLocation = `${source}:${lineno}:${colno}`;
    errorLogger.logError({ message, stack: stackTrace }, source || "window.onerror");
  };

  // Promise rejection handler
  window.addEventListener('unhandledrejection', function(event) {
    errorLogger.logError(event.reason, "unhandledrejection");
  });
}

// Axios interceptors
// Set withCredentials to true by default for enrollment APIs
// Graph API calls will temporarily set it to false
//axios.defaults.withCredentials = true;

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const where = error?.config?.url || "axios.response";
    errorLogger.logError(error, where);
    return Promise.reject(error);
  }
);

export default errorLogger;
